<div class="card">
  <div class="card-header card-chart card-header-primary">
    <h5 class="card-title text-center"><b>-----------</b></h5>
  </div>
  <div class="card-body">
    <div class="container">
      <div class="row">
        <!--Nombre-->
        <div class="col-sm-6">
              <mat-form-field class="example-full-width">
                <input [ngModel]="" matInput aria-label="Nombre" type="text" placeholder="Nombre" disabled>
              </mat-form-field>
        </div>
        <!--Apellido Paterno-->
        <div class="col-sm-6">
          <mat-form-field class="example-full-width">
            <input  [ngModel]="" matInput aria-label="Apellido Paterno" type="text" placeholder="Apellido Paterno" disabled>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <!--Apellido Materno-->
        <div class="col-sm-6">
          <mat-form-field class="example-full-width">
            <input [ngModel]="" matInput aria-label="Apellido Materno" type="text" placeholder="Apellido Materno" disabled>
          </mat-form-field>
        </div>
        <!--Email-->
        <div class="col-sm-6">
          <mat-form-field class="example-full-width">
            <input [ngModel]="" matInput aria-label="Email" type="text" placeholder="Email" disabled>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <!--Uusuario-->
        <div class="col-sm-6">
          <mat-form-field class="example-full-width">
            <input [ngModel]="" matInput aria-label="Usuario" type="text" placeholder="Usuario" disabled>
          </mat-form-field>
        </div>
        <!--x-->
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12 cent">
            <button mat-raised-button class="btn btn-info btn-sm" (click)="onNoClick()">
              <span><i class="material-icons">cancel</i></span>
              &nbsp; Salir
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>